import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import { MessageCircle } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const PARTNER_TOKEN_KEY = 'am_partner_chat_token';
export const PARTNER_SEEN_KEY = 'am_partner_chat_seen';

export const chime = () => {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    [880, 1320].forEach((f, i) => {
      const o = ctx.createOscillator(); const g = ctx.createGain();
      o.frequency.value = f; o.connect(g); g.connect(ctx.destination);
      const t = ctx.currentTime + i * 0.15;
      g.gain.setValueAtTime(0.18, t); g.gain.exponentialRampToValueAtTime(0.001, t + 0.3);
      o.start(t); o.stop(t + 0.3);
    });
    setTimeout(() => ctx.close().catch(() => {}), 800);
  } catch { /* audio blocked */ }
};

export const notifyPartner = (title, body) => {
  if ('Notification' in window && Notification.permission === 'granted' && document.hidden) {
    try { new Notification(title, { body, icon: '/acremitra-logo.png', tag: 'partner-chat' }); } catch { /* ignore */ }
  }
};

// Floating unread badge shown on every page (except the chat itself) for signed-in partners.
export const PartnerChatBadge = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [count, setCount] = useState(0);
  const prev = useRef(0);
  const token = localStorage.getItem(PARTNER_TOKEN_KEY);
  const hidden = !token || pathname.startsWith('/partner-chat') || pathname.startsWith('/admin') || pathname.startsWith('/room');
  useEffect(() => {
    if (hidden) return undefined;
    const check = async () => {
      try {
        const { data } = await axios.get(`${API}/partner/chat/unread`, {
          headers: { Authorization: `Bearer ${token}` }, params: { since: localStorage.getItem(PARTNER_SEEN_KEY) || undefined },
        });
        if (data.count > prev.current) { chime(); notifyPartner(`${data.last?.name || 'Partner'} · AcreMitra Partners`, data.last?.text || 'Shared an image'); }
        prev.current = data.count;
        setCount(data.count);
      } catch (e) { if (e.response?.status === 401) localStorage.removeItem(PARTNER_TOKEN_KEY); }
    };
    check();
    const t = setInterval(check, 15000);
    return () => clearInterval(t);
  }, [hidden, token]);
  if (hidden || !count) return null;
  return (
    <button type="button" onClick={() => navigate('/partner-chat')} data-testid="partner-chat-badge"
      className="fixed left-4 bottom-24 z-[300] inline-flex items-center gap-2 rounded-full bg-emerald-700 text-white pl-3 pr-4 py-2.5 shadow-xl hover:bg-emerald-800 transition-colors">
      <span className="relative"><MessageCircle size={20} />
        <span className="absolute -top-2 -right-2 min-w-[18px] h-[18px] rounded-full bg-red-600 text-[10px] font-bold grid place-items-center px-1 animate-pulse" data-testid="partner-chat-badge-count">{count > 99 ? '99+' : count}</span>
      </span>
      <span className="text-sm font-semibold">Partner chat</span>
    </button>
  );
};
